import SharedDynamicPage from "../../../pages/DynamicPage";
import Header from "../../../components/Shared/Header";
import Footer from "../../../components/Shared/Footer";
import PageLayout from "../../../components/Shared/PageLayout";

export default function DynamicPage() {
  return (
    <PageLayout header={<Header />} footer={<Footer />}>
      <SharedDynamicPage />
    </PageLayout>
  );
}
